import { Button, Input, LoadingButton, Select } from "components/form";
import {
  OPTION_NUMBER,
  RATING_NUMBER,
  RATING_NUMBER1,
  SURVEY_IMAGE_POSITION,
  SURVEY_MULTIPLY_CHOICE,
  SURVEY_RANKING_NUMBER,
  surveyFormValue,
} from "constant/staticData";
import React, { useState, useTransition } from "react";
import { useTranslation } from "react-i18next";

const SurveyQuestionSettingValue = ({
  data,
  title,
  indexValue,
  handleClose,
  selectedBlock,
  setSurveyQuestionArray,
}) => {
  // Initializing state with default or passed data
  const defaultValue = {
    optionType: surveyFormValue?.SURVEY_MULTIPLE_OPTION || "",
    imagePositon: surveyFormValue?.SURVEY_IMAGE_POSITION || "",
    textAreaMin: surveyFormValue?.MIN_TEXT_AREA_LIMIT || "",
    textAreaMax: surveyFormValue?.MAX_TEXT_AREA_LIMIT || "",
    sliderMin: surveyFormValue?.MIN_SLIDER_LIMIT || "",
    sliderMax: surveyFormValue?.MAX_SLIDER_LIMIT || "",
    rankCount: surveyFormValue?.SURVEY_RANK_COUNT || "",
    starCount: surveyFormValue?.STAR_COUNT || "",
  };

  const { t } = useTranslation();

  const modalTypes = {
    multiple: (value, handleChange) => (
      <div className="form_field">
        <Select
          label={t(`CUSTOMIZATION_QUESTION.multipleAnswer`)}
          // placeholder="Select Mutliple Option Type"
          name="optionType"
          value={value?.optionType || ""}
          onChange={handleChange}
        >
          {SURVEY_MULTIPLY_CHOICE.map((data, index) => (
            <option key={data?.value || index} value={data?.value || ""}>
              {t(`CUSTOMIZATION_QUESTION.${data?.label}`) || ""}
            </option>
          ))}
        </Select>
      </div>
    ),

    text: (value, handleChange) => (
      <>
        <div className="form_field">
          <Input
            type="text"
            placeholder={t(`CUSTOMIZATION_QUESTION.minimum`)}
            name="textAreaMin"
            label={t(`CUSTOMIZATION_QUESTION.minimum`)}
            value={value?.textAreaMin}
            onChange={handleChange}
            maxLength={320}
          />
        </div>
        <div className="form_field">
          <Input
            type="text"
            placeholder={t(`CUSTOMIZATION_QUESTION.maximum`)}
            name="textAreaMax"
            label={t(`CUSTOMIZATION_QUESTION.maximum`)}
            value={value?.textAreaMax}
            onChange={handleChange}
            maxLength={320}
          />
        </div>
      </>
    ),

    image: (value, handleChange) => (
      <div className="form_field">
        <Select
          label={t(`CUSTOMIZATION_QUESTION.displayImage`)}
          // options={region}
          placeholder={t(`CUSTOMIZATION_QUESTION.selectDisplayImage`)}
          name="imagePositon"
          value={value?.imagePositon || ""}
          onChange={handleChange}
        >
          {SURVEY_IMAGE_POSITION.map((data, index) => (
            <option key={data?.value || index} value={data?.value || ""}>
              {t(`CUSTOMIZATION_QUESTION.${data?.label}`) || ""}
            </option>
          ))}
        </Select>
      </div>
    ),

    rankorder: (value, handleChange) => (
      <div className="form_field">
        <Select
          label={t(`CUSTOMIZATION_QUESTION.selectNumberRankingDescription`)}
          // options={region}
          placeholder={t(`CUSTOMIZATION_QUESTION.selectNumberRanking`)}
          name="rankCount"
          value={value?.rankCount || ""}
          onChange={handleChange}
        >
          {OPTION_NUMBER.map((data, index) => (
            <option key={data?.value || index} value={data?.value || ""}>
              {data?.label || ""}
            </option>
          ))}
        </Select>
      </div>
    ),

    slider: (value, handleChange) => (
      <>
        <div className="form_field">
          <Input
            type="text"
            maxLength={320}
            name="sliderMin"
            label={t(`CUSTOMIZATION_QUESTION.minimumValue`)}
            onChange={handleChange}
            value={value?.sliderMin}
            placeholder={t(`CUSTOMIZATION_QUESTION.minimumValue`)}
          />
        </div>
        <div className="form_field">
          <Input
            type="text"
            maxLength={320}
            name="sliderMax"
            label={t(`CUSTOMIZATION_QUESTION.maximumValue`)}
            onChange={handleChange}
            value={value?.sliderMax}
            placeholder={t(`CUSTOMIZATION_QUESTION.maximumValue`)}
          />
        </div>
      </>
    ),

    rating: (value, handleChange) => (
      <div className="form_field">
        <Select
          // options={region}
          name="starCount"
          onChange={handleChange}
          value={value?.starCount || ""}
          // placeholder="Select Rating Number"
          label={t(`CUSTOMIZATION_QUESTION.selectNoRating`)}
        >
          {RATING_NUMBER1?.map((data, index) => (
            <option key={data?.value || index} value={data?.value || ""}>
              {data?.label || ""}
            </option>
          ))}
        </Select>
      </div>
    ),
  };

  // Set all value
  const [settingValue, setSettingValue] = useState(
    data?.setting || defaultValue
  );

  // Handle Function

  // Handle change for the input fields dynamically
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSettingValue((prevState) => ({
      ...prevState,
      [name]: ["optionType", "imagePositon"].includes(name)
        ? value
        : Number(value),
    }));
  };

  const applySettingValue = (type) => {
    setSurveyQuestionArray((prevSurveyQuestionArray) => {
      const updatedSurveyArray = { ...prevSurveyQuestionArray };
      const updatedBlock = [...updatedSurveyArray[selectedBlock]];
      updatedBlock[indexValue] = {
        ...updatedBlock[indexValue],
        setting: settingValue,
        option:
          type === "rankorder"
            ? Array.from(
                { length: settingValue?.rankCount || 4 },
                (_, index) => ({
                  optionValue: "",
                  optionImage: "",
                  questionNumber: "",
                  rank: index + 1,
                })
              )
            : updatedBlock?.[indexValue]?.option,
      };
      updatedSurveyArray[selectedBlock] = updatedBlock;
      return updatedSurveyArray;
    });
    handleClose();
  };

  // Get the question type dynamically and render the modal type
  const renderModalType = data?.questionType && modalTypes[data.questionType];

  return (
    <div>
      <h3>{title || ""}</h3>
      {/* <p>{data?.question || "Survey Question"}</p> */}
      <div>
        {renderModalType ? (
          renderModalType(settingValue, handleChange)
        ) : (
          <p>{t(`CUSTOMIZATION_QUESTION.novalidTypeSelected`)} </p>
        )}
      </div>
      <div className="button_wrap">
        <LoadingButton
          className="light"
          onClick={() => applySettingValue(data?.questionType)}
        >
          {t(`CUSTOMIZATION_QUESTION.apply`)}
        </LoadingButton>
        <Button onClick={handleClose}>
          {t(`CUSTOMIZATION_QUESTION.cancel`)}
        </Button>
      </div>
    </div>
  );
};

export default SurveyQuestionSettingValue;
